module.exports = __webpack_public_path__ + "static/media/offerBanner2.b835a999.png";